function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (!elementToFocus) {
    return;
  }

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video:not(.always-on)').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if ((parseInt(this.input.dataset.min) > parseInt(this.input.step)) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp()
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if ((this.input.dataset.min === previousValue) && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut(event) {
    if (event.relatedTarget && event.relatedTarget.tagName === 'SELECT' && this.mainDetailsToggle.contains(event.relatedTarget)) {
      // Prevent the focusout event from propagating
      event.stopPropagation();

      // Use setTimeout to delay focusing until after the select dropdown has opened
      setTimeout(() => {
        event.relatedTarget.focus();
      }, 10); // A delay of 10ms is usually enough, but this can be adjusted based on testing

      return;
    }

    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

window.onpageshow = function (event) {
  if (event.persisted) {
    const headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer.mainDetailsToggle.hasAttribute('open')) { return; } // Check if menu is open
    setTimeout(() => {
      const summary = headerDrawer.mainDetailsToggle.querySelector('summary');
      if (headerDrawer) summary.click();
    });
  }
};

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code?.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    // window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    // window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalLocalization extends ModalDialog {
  constructor() {
    super();
    // The language selector is created dynamically based on the country selected
    this.languageSelector = this.querySelector('.modal-language-selector');
    this.settings = {
      // Default mapping with English for all countries
      languagesByCountry: {
        'default': ['EN']
      }
    };

    // Central configuration for country-language mappings and localized names
    this.countryConfig = {
      'FR': { languages: ['FR', 'EN'], localizedName: 'France' },
      'DE': { languages: ['DE', 'EN', 'FR'], localizedName: 'Deutschland' },
      'IT': { languages: ['IT', 'EN', 'FR'], localizedName: 'Italia' },
      'ES': { languages: ['ES', 'EN', 'FR'], localizedName: 'España' },
      'PT': { languages: ['PT', 'EN', 'FR'], localizedName: 'Portugal' },
      'NL': { languages: ['NL', 'EN', 'FR'], localizedName: 'Nederland' },
      'JP': { languages: ['JP', 'EN', 'FR'], localizedName: '日本' },
      'KR': { languages: ['KR', 'EN', 'FR'], localizedName: '대한민국' },
      'CN': { languages: ['CN', 'EN', 'FR'], localizedName: '中国' },
      'CL': { languages: ['ES', 'EN', 'FR'], localizedName: 'Chile' },
      'MX': { languages: ['ES', 'EN', 'FR'], localizedName: 'México' },
      'CO': { languages: ['ES', 'EN', 'FR'], localizedName: 'Colombia' },
      'PE': { languages: ['ES', 'EN', 'FR'], localizedName: 'Perú' },
      'TW': { languages: ['TW', 'EN', 'FR'], localizedName: '臺灣' },
      'TH': { languages: ['TH', 'EN', 'FR'], localizedName: 'ประเทศไทย' },
      'DK': { languages: ['DK', 'EN', 'FR'], localizedName: 'Danmark' },
      'SE': { languages: ['SE', 'EN', 'FR'], localizedName: 'Sverige' },
      'NO': { languages: ['NO', 'EN', 'FR'], localizedName: 'Norge' },
      'AT': { languages: ['DE', 'EN', 'FR'], localizedName: 'Österreich' },
      'PL': { languages: ['PL', 'EN', 'FR'], localizedName: 'Polska' },
      'RO': { languages: ['RO', 'EN', 'FR'], localizedName: 'România' },
      'BG': { languages: ['BG', 'EN', 'FR'], localizedName: 'България' },
      'GR': { languages: ['GR', 'EN', 'FR'], localizedName: 'Ελλάδα' },
      'default': { languages: ['EN', 'FR'], localizedName: '' }
    };

    this.init();
  }

  isInit = false;

  async init() {
    this.querySelector('form')?.addEventListener('submit', this.onFormSubmit.bind(this));
    await this.initializeCountries();
    // this.updateLanguageOptions();

    // Initialize the language mapping based on country options
    this.initializeLanguageMapping();
    this.localizeCountryNames();
    this.initEventListeners();
  }

  get countrySelector() {
    return this.querySelector('.modal-country-selector');
  }

  get opener() {
    return document.querySelector(`[data-modal="#${this.id}"] button`);
  }

  get currentLanguage() {
    if ((!window.glopal || !window.glopal.config) && window.Shopify) return window.Shopify.locale.toUpperCase();
    if (!window.glopal || !window.glopal.config) return 'EN';
    return window.glopal.config.target.countryCode.toUpperCase();
  }

  async initializeCountries() {
    if (!this.countrySelector) return;

    const response = await fetch('/en/?section_id=countries-in-english');
    const html = await response.text();
    const parser = new DOMParser();

    // In the html there is a select with the countries
    const countrySelect = parser.parseFromString(html, 'text/html').querySelector('select');
    if (!countrySelect) return;
    const countryOptions = Array.from(countrySelect.options);
    this.countrySelector.innerHTML = '';

    countryOptions.forEach(option => {
      this.countrySelector.appendChild(option.cloneNode(true));
    });

    const openerContent = parser.parseFromString(html, 'text/html').querySelector('.opener-content');
    if (!this.opener || !openerContent) return;
    this.opener.innerHTML = openerContent.innerHTML;
  }

  initializeLanguageMapping() {
    // Set default English for all countries
    if (!this.countrySelector) return;

    const countryOptions = Array.from(this.countrySelector.options);

    // Add mappings for all available country options
    countryOptions.forEach(option => {
      const countryCode = option.value;
      if (countryCode && countryCode !== '') {
        this.settings.languagesByCountry[countryCode] =
          this.countryConfig[countryCode]?.languages || this.countryConfig['default'].languages;
      }
    });
  }

  localizeCountryNames() {
    if (!this.countrySelector) return;

    const countryOptions = Array.from(this.countrySelector.options);

    countryOptions.forEach(option => {
      const countryCode = option.value;
      if (countryCode && countryCode !== '') {
        const localizedName = this.countryConfig[countryCode]?.localizedName;
        if (localizedName && option.dataset.countryName !== localizedName) {
          // Store the localized name as a data attribute instead of changing the text content
          option.dataset.localizedName = localizedName;
          // Add a span with the localized name after the option text
          option.innerHTML = `${option.textContent} <span class="country-localized-name">(${localizedName})</span>`;
        }
      }
    });

    if (!this.opener) return;
    const openerCountryName = this.opener.querySelector('.js-country-name');
    const selectedOption = this.countrySelector.options[this.countrySelector.selectedIndex];
    if (openerCountryName) openerCountryName.textContent = selectedOption.dataset.localizedName || selectedOption.textContent;

    const openerLanguageName = this.opener.querySelector('.js-language-name');
    if (openerLanguageName) openerLanguageName.textContent = this.getLanguageLabel(this.currentLanguage);
  }

  initEventListeners() {
    if (this.countrySelector) {
      this.countrySelector.addEventListener('change', this.updateLanguageOptions.bind(this));
      // Initialize language options based on default country selection
      this.updateLanguageOptions();
    }
  }

  updateLanguageOptions() {
    if (!this.languageSelector) return;

    const selectedCountry = this.countrySelector.value;
    const availableLanguages = this.settings.languagesByCountry[selectedCountry] || this.settings.languagesByCountry['default'];

    // Clear existing options
    this.languageSelector.innerHTML = '';

    // Add new options based on available languages
    availableLanguages.forEach(lang => {
      const option = document.createElement('option');
      option.value = lang;
      option.textContent = this.getLanguageLabel(lang);
      if (lang === this.currentLanguage && this.isInit === false) {
        option.selected = true;
      }
      this.languageSelector.appendChild(option);
    });

    this.isInit = true;
  }

  getLanguageLabel(langCode) {
    const languageLabels = {
      'EN': 'English',
      'FR': 'Français',
      'CN': '中文',
      'DE': 'Deutsch',
      'ES': 'Español',
      'IT': 'Italiano',
      'JP': '日本語',
      'KR': '한국어',
      'NL': 'Nederlands',
      'PT': 'Português',
      'TW': '繁體中文',
      'TH': 'ภาษาไทย',
      'DK': 'Dansk',
      'SE': 'Svenska',
      'NO': 'Norsk',
      'PL': 'Polski',
      'RO': 'Română',
      'BG': 'Български',
      'GR': 'Ελληνικά'
    };

    return languageLabels[langCode] || langCode;
  }

  onFormSubmit(event) {
    event.preventDefault();
    const selectedCountry = this.countrySelector.value;
    const selectedLanguage = this.languageSelector.value;

    // Get the current path
    let currentPath = window.location.pathname;

    // Remove any existing language prefix from the current path
    const languagePrefixRegex = /^\/(en|fr|cn|de|es|it|jp|kr|nl|pt|tw|th|dk|se|no|pl|ro|bg|gr)\//i;
    const languageMatch = currentPath.match(languagePrefixRegex);
    if (languageMatch) {
      currentPath = currentPath.substring(languageMatch[0].length);
    }

    // Also check if the path itself is just a language code (like /de) and remove it
    const pathLanguageOnlyRegex = /^\/(en|fr|cn|de|es|it|jp|kr|nl|pt|tw|th|dk|se|no|pl|ro|bg|gr)$/i;
    if (pathLanguageOnlyRegex.test(currentPath)) {
      currentPath = '/';
    }

    // Ensure there's a leading slash
    if (!currentPath.startsWith('/')) {
      currentPath = '/' + currentPath;
    }

    // Build the base domain URL based on selected language
    let url = `https://${(selectedLanguage === 'FR' || selectedLanguage === 'EN') ? 'www' : selectedLanguage.toLowerCase()}.${this.getDomainWithoutSubdomain()}`;

    // Add the correct language path prefix if needed
    if (selectedLanguage !== 'FR') {
      // For non-FR languages, add the language code to the URL path
      const langPath = selectedLanguage.toLowerCase();
      url += `/${langPath}`;

      // Only add the currentPath if it's not just a root path
      if (currentPath !== '/') {
        url += currentPath;
      }
    } else {
      // For FR language, just append the current path
      url += currentPath;
    }

    // Append the country parameter
    url += (url.includes('?') ? '&' : '?') + `country=${selectedCountry}`;

    window.location.href = url;
  }

  getDomainWithoutSubdomain() {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');

    // Handle cases like 'localhost' or IP addresses
    if (parts.length <= 1) return hostname;

    // For domains like 'example.com' or ones with TLDs like '.co.uk'
    if (parts.length === 2) return hostname;

    // For domains like 'subdomain.example.com'
    // Get just the main domain and TLD
    return parts.slice(-2).join('.');
  }
}

customElements.define('modal-localization', ModalLocalization);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal && modal.show) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!this.poster) return;
    this.poster.addEventListener('click', this.loadContent.bind(this));

    (async () => {
      if (this.hasAttribute('data-autoplay')) {
        await this.untilVisible();
        this.loadContent(false);
      }
    })();
  }

  untilVisible(intersectionObserverOptions = { rootMargin: "0px 0px -50px 0px" }) {
    const onBecameVisible = () => {
      this.classList.add("became-visible");
      this.style.opacity = "1";
    };
    return new Promise((resolve) => {
      if (window.IntersectionObserver) {
        this.intersectionObserver = new IntersectionObserver((event) => {
          if (event[0].isIntersecting) {
            this.intersectionObserver.disconnect();
            requestAnimationFrame(() => {
              resolve();
              onBecameVisible();
            });
          }
        }, intersectionObserverOptions);
        this.intersectionObserver.observe(this);
      } else {
        resolve();
        onBecameVisible();
      }
    });
  }

  loadContent(focus = true) {
    // window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      if (!this.querySelector('template').content.firstElementChild) {
        return;
      }

      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.hasAttribute('data-desktop-sources')) {
        if (deferredElement.hasAttribute('data-mobile-sources') && window.matchMedia('(max-width: 749px)').matches) {
          const mobileSources = JSON.parse(deferredElement.dataset.mobileSources);
          mobileSources.forEach((source) => {
            const sourceElem = document.createElement('source');
            sourceElem.src = source.src;
            sourceElem.type = source.type;
            deferredElement.append(sourceElem);
          });
        } else {
          const desktopSources = JSON.parse(deferredElement.dataset.desktopSources);
          desktopSources.forEach((source) => {
            const sourceElem = document.createElement('source');
            sourceElem.src = source.src;
            sourceElem.type = source.type;
            deferredElement.append(sourceElem);
          });
        }
      }
      if (deferredElement.hasAttribute('muted')) deferredElement.muted = true;
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.hasAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.isMobile = window.matchMedia('(max-width: 749px)').matches;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const formData = new FormData(this.form);
        if (!formData.get('id') && this.dataset.variantsErrors) {
          this.handleErrorMessage(this.dataset.variantsErrors);

          const variantSelector = document.querySelector('variant-selects');
          if (this.isMobile && variantSelector) {
            variantSelector.scrollIntoView({ behavior: 'smooth', block: "start" });
          }
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelectorAll('.loading__spinner').forEach((spinner) => spinner.classList.remove('hidden'));

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        console.log('fetch_url', routes.cart_add_url);
        console.log('body', config.body);

        fetch(window.Shopify.routes.root + 'cart/add', config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelectorAll('.loading__spinner').forEach((spinner) => spinner.classList.add('hidden'));
            document.querySelectorAll('.loading-effect').forEach((label) => label.classList.remove('loading-effect'));
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    if (!event.target.hasAttribute('form') && event.target.name !== 'id') return;
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    console.log(this.currentVariant);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select[form], fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input[form]')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }


  updateMedia(html) {
    const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
    const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);

    const refreshSourceData = () => {
      const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
      const sourceSet = new Set(mediaGallerySourceItems.map(item => item.dataset.mediaId));
      const sourceMap = new Map(mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }]));
      return [mediaGallerySourceItems, sourceSet, sourceMap];
    };

    if (mediaGallerySource && mediaGalleryDestination) {
      let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
      const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
      const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
      let shouldRefresh = false;

      // add items from new data not present in DOM
      for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
          mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
          shouldRefresh = true;
        }
      }

      // remove items from DOM not present in new data
      for (let i = 0; i < mediaGallerySourceItems.length; i++) {
        if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
          mediaGallerySourceItems[i].remove();
          shouldRefresh = true;
        }
      }

      // refresh
      if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

      // if media galleries don't match, sort to match new data order
      mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
        const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

        if (sourceData && sourceData.index !== destinationIndex) {
          mediaGallerySource.insertBefore(sourceData.item, mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`));

          // refresh source now that it has been modified
          [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
        }
      });
    }

    // document.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`).setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media?.id}`);

    // update media modal
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newModalContent = html.querySelector(`product-modal`);
    if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const priceButtonDestination = document.getElementById(`price-button-${this.dataset.section}`);
        const priceButtonSource = html.getElementById(
          `price-button-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const priceSizeButtonDestination = document.getElementById(`price-size-button-${this.dataset.section}`);
        const priceSizeButtonSource = html.getElementById(
          `price-size-button-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        this.updateMedia(html);

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (priceButtonSource && priceButtonDestination) {
          priceButtonDestination.innerHTML = priceButtonSource.innerHTML;
        }
        if (priceSizeButtonSource && priceSizeButtonDestination) {
          priceSizeButtonDestination.innerHTML = priceSizeButtonSource.innerHTML;
        }
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        const priceButton = document.getElementById(`price-button-${this.dataset.section}`);
        const priceSizeButton = document.getElementById(`price-size-button-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');
        if (priceButton) priceButton.classList.remove('hidden');
        if (priceSizeButton) priceSizeButton.classList.remove('hidden');


        if (inventoryDestination)
          inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const backInStockOpener = productForm.querySelector('.back-in-stock__opener');
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (backInStockOpener && text) backInStockOpener.classList.remove('hidden');
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if (backInStockOpener) backInStockOpener.classList.add('hidden');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const priceButton = document.getElementById(`price-button-${this.dataset.section}`);
    const priceSizeButton = document.getElementById(`price-size-button-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (priceButton) priceButton.classList.add('hidden');
    if (priceSizeButton) priceSizeButton.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantBuyButtons extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onButtonClick);
  }

  onButtonClick(event) {
    const button = event.target.closest('button');
    if (!button) return;

    const variantId = button.dataset.variantId;
    if (!variantId || !button.dataset.form) return;

    const productForm = document.getElementById(button.dataset.form);
    if (!productForm) return;

    const input = productForm.querySelector('input[name="id"]');
    if (!input) return;

    input.value = variantId;
    productForm.dispatchEvent(new Event('submit', { cancelable: true }));
    button.classList.add('loading');
  }
}

customElements.define('variant-buy-buttons', VariantBuyButtons);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');

            if (this.closest('.section--related-products')) {
              this.closest('.section--related-products').classList.add('recommendations-loaded');
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class LibraryLoader {
  static STATUS_REQUESTED = "requested";
  static STATUS_LOADED = "loaded";
  static libraries = {
    splide: {
      tagId: "splide",
      src: window.libs.splide,
      type: "script"
    },
    splideAutoScroll: {
      tagId: "splide-auto-scroll",
      src: window.libs.splideAutoScroll,
      type: "script"
    }
  };

  static load(libraryName) {
    const library = this.libraries[libraryName];
    if (!library) return;
    if (library.status === this.STATUS_REQUESTED) return library.promise;
    if (library.status === this.STATUS_LOADED) return Promise.resolve();
    const promise = new Promise((resolve, reject) => {
      const tag = library.type === "script" ? document.createElement("script") : document.createElement("link");
      tag.id = library.tagId;
      tag.onerror = reject;
      tag.onload = () => {
        library.status = this.STATUS_LOADED;
        resolve();
      };
      if (library.type === "script") {
        tag.src = library.src;
      } else {
        tag.href = library.src;
        tag.rel = "stylesheet";
        tag.type = "text/css";
      }
      document.body.appendChild(tag);
    });
    library.promise = promise;
    library.status = this.STATUS_REQUESTED;
    return promise;
  }
}

class SplideCarousel extends HTMLElement {
  constructor() {
    super();
    this.sliderNode = this;
  }

  connectedCallback() {
    if (this.slideNodes.length < 2) return;
    this.initVideoDurations();
    this._createSplide();
  }

  disconnectedCallback() {
    if (this.splideInstance) this.splideInstance.destroy();
  }

  initVideoDurations() {
    const mq = window.matchMedia('(min-width: 750px)');
    const slides = this.querySelectorAll('[data-splide-desktop-interval]');

    slides.forEach((slide) => {
      slide.setAttribute('data-splide-interval', mq.matches ? slide.dataset.splideDesktopInterval : slide.dataset.splideMobileInterval);
    });
  }

  get slideNodes() {
    return this.querySelectorAll(".splide__slide");
  }

  get splideConfig() {
    return JSON.parse(this.getAttribute("splide-config")) || {};
  }

  get splideInstance() {
    return this.splide;
  }

  _lazyLoad() {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        this.splideInstance.Components.Slides.forEach((Slide) => {
          Slide.slide.querySelectorAll('img[loading="lazy"]').forEach((img) => {
            img.setAttribute('loading', 'eager');
          });
        });
        observer.unobserve(this);
      }
    });
    observer.observe(this);
  }

  _addEventListeners() {
    const onVideoEnd = (event) => {
      if (event.target.closest('.splide__slide.is-active')) {
        this.splideInstance.go('>');
      }
    }

    this.splideInstance.on('ready', () => {
      if (!this.slideNodes.length) return;

      const firstSlideVideo = this.slideNodes[0].querySelector('video');

      // if (firstSlideVideo) {
      //   firstSlideVideo.play();
      // }

      if (firstSlideVideo && !firstSlideVideo.hasAttribute('event-added')) {
        firstSlideVideo.setAttribute('event-added', true);
        firstSlideVideo.addEventListener('ended', onVideoEnd);
      }
    });

    this.splideInstance.on('active', (slideComponent) => {
      // Check if the slide is a clone
      if (slideComponent.slide.classList.contains('splide__slide--clone')) {
        return;
      }

      const video = slideComponent.slide.querySelector('video');
      const lazyVideo = slideComponent.slide.querySelector('lazy-video');

      if (lazyVideo) {
        lazyVideo.play();
      } else if (video) {
        video.play();
      }

      if (video && !video.hasAttribute('event-added')) {
        video.setAttribute('event-added', true);
        video.addEventListener('ended', onVideoEnd);
      }
    });

    this.splideInstance.on('inactive', (slideComponent) => {
      const video = slideComponent.slide.querySelector('video');
      const lazyVideo = slideComponent.slide.querySelector('lazy-video');

      if (lazyVideo) {
        lazyVideo.stop();
      } else if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  async _createSplide() {
    await LibraryLoader.load("splide");
    if (document.querySelector('[data-auto-scroll]')) {
      await LibraryLoader.load("splideAutoScroll");
    }
    this.splide = new Splide(this.sliderNode, {
      ...this.splideConfig,
      drag: this.splideConfig.drag ?? this.slideNodes.length > 1
    });
    this._lazyLoad();
    this._addEventListeners();
    if (this.querySelector('[data-auto-scroll]')) {
      this.splide.mount(window.splide.Extensions);
    } else {
      this.splide.mount();
    }
    this.dispatchEvent(new CustomEvent("splide:mounted", { bubbles: true }));
  }
}
customElements.define("splide-carousel", SplideCarousel);

class SliderComponent extends SplideCarousel {
  constructor() {
    super();
    this.list = this.querySelector('.slider');
    if (!this.list) return;

    this.addSplideClasses();
  }

  get sliderVisibility() {
    const devices = ['mobile', 'tablet', 'desktop'];
    let sliderVisibility = 'everywhere';

    devices.forEach(device => {
      if (this.list.classList.contains(`slider--${device}`)) {
        sliderVisibility = device;
      }
    });

    if (this.list.classList.contains('slider--desktop') && this.list.classList.contains('slider--tablet')) {
      sliderVisibility = 'everywhere';
    }

    return sliderVisibility;
  }

  getColumns(device) {
    const gridClasses = Array.from(this.list.classList).filter((className) => className.includes('grid--') && className.includes('col'));

    const deviceMapping = {
      'mobile': ['col-mobile', 'col-tablet-down'],
      'everywhere': ['col-mobile', 'col-tablet-down'],
      'tablet': ['col-tablet', 'col-tablet-down'],
      'desktop': ['col-desktop']
    };

    let columns;

    if (device in deviceMapping) {
      for (let deviceClass of deviceMapping[device]) {
        columns = gridClasses.find((className) => className.includes(deviceClass))?.split('-')[2];
        if (columns) break;
      }
    }

    if (!columns) {
      columns = gridClasses.find((className) => className.includes('grid--') && !className.includes('tablet') && !className.includes('desktop'))?.split('--')[1].split('-')[0];
    }

    return parseInt(columns) || 1;
  }

  addSplideClasses() {
    this.classList.add("splide");
    this.list.classList.add('splide__list');

    const slides = this.querySelectorAll('.slider__slide');
    slides.forEach((slide) => {
      slide.classList.add('splide__slide');
    });

    const track = document.createElement('div');
    track.classList.add('splide__track');

    // Put the list inside the track
    track.appendChild(this.list);

    // Put the track inside the slider at the first position
    this.prepend(track);
  }

  connectedCallback() {
    if (!this.list) return;
    super.connectedCallback();
  }

  getGapByDevice(device) {
    const spacing = (device === 'mobile' || device === 'everywhere') ? '--grid-mobile-horizontal-spacing' : '--grid-desktop-horizontal-spacing';
    const defaultGap = (device === 'mobile' || device === 'everywhere') ? 15 : 50;

    return `${parseInt(getComputedStyle(this.list).getPropertyValue(spacing))}px`;
  }

  getPaddingByDevice(device) {
    return (device === 'mobile' || device === 'everywhere') ? { left: "1.5rem", right: "1.5rem" } : { left: "5rem", right: "5rem" };
  }

  get splideConfig() {
    if (this.hasAttribute("splide-config")) {
      return JSON.parse(this.getAttribute("splide-config"));
    }

    let config = {
      type: 'loop',
      arrows: false,
      pagination: false,
      perMove: 1,
      omitEnd: true,
      trimSpace: true,
      resetProgress: false,
      autoplay: this.list.dataset.autoplay === 'true',
      interval: this.list.dataset.speed ? parseInt(this.list.dataset.speed) * 1000 : 5000,
    };

    const devices = ['mobile', 'tablet', 'desktop', 'everywhere'];
    devices.forEach(device => {
      if (this.sliderVisibility === device) {
        config.mediaQuery = device === 'desktop' ? 'max' : 'min';
        config.padding = this.getPaddingByDevice(device);
        config.perPage = this.getColumns(device);
        config.gap = this.getGapByDevice(device);
        config.breakpoints = this.getBreakpoints(device);
        config.autoScroll = (device === 'desktop' && this.list.dataset.autoScroll) || (this.list.dataset.autoScroll && !this.list.hasAttribute('data-auto-scroll-desktop')) ? {
          speed: Number(this.list.dataset.autoScroll),
        } : false;
      }
    });

    return config;
  }

  getBreakpoints(device) {
    let breakpoints = {};
    if (device === 'mobile') {
      breakpoints = {
        750: {
          destroy: true
        }
      };
    } else if (device === 'tablet') {
      breakpoints = {
        750: {
          gap: this.getGapByDevice('tablet'),
          perPage: this.getColumns('tablet'),
          padding: this.getPaddingByDevice('tablet')
        },
        990: {
          destroy: true
        }
      };
    } else if (device === 'desktop') {
      breakpoints = {
        990: {
          destroy: true
        }
      };
    } else if (device === 'everywhere') {
      breakpoints = {
        750: {
          perPage: this.getColumns('tablet'),
          gap: this.getGapByDevice('tablet'),
          padding: this.getPaddingByDevice('tablet')
        },
        990: {
          perPage: this.getColumns('desktop'),
          autoScroll: this.list.dataset.autoScroll ? {
            speed: Number(this.list.dataset.autoScroll),
          } : false,
        }
      };
    }
    return breakpoints;
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
  }

  getPaddingByDevice(device) {
    return { left: "0", right: "0" };
  }

  getGapByDevice(device) {
    return "0";
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class LazyVideo extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.mediaWrapper = this.closest(this.dataset.hoverPlay) || this;
    this.mediaQueryList = window.matchMedia('(max-width: 749px)');
    this.changeSourcesOnResize = this.changeSourcesOnResize.bind(this);
    this.play = this.play.bind(this);
    this.stop = this.stop.bind(this);

    (async () => {
      if (this.hasAttribute('data-autoplay-viewport')) {
        await this.untilVisible();
        this.play();
      }
    })();
  }

  connectedCallback() {
    this.setPoster();
    this.mediaQueryList.addEventListener('change', this.changeSourcesOnResize);

    if (this.hasAttribute('data-hover-play') && this.mediaWrapper) {
      this.mediaWrapper.addEventListener('mouseenter', this.play);
      this.mediaWrapper.addEventListener('mouseleave', this.stop);
    }
  }

  setPoster() {
    if (this.video.hasAttribute('data-mobile-poster') && this.mediaQueryList.matches) {
      this.video.poster = this.video.dataset.mobilePoster;
    } else if (this.video.hasAttribute('data-desktop-poster') && !this.mediaQueryList.matches) {
      this.video.poster = this.video.dataset.desktopPoster;
    }
  }

  disconnectedCallback() {
    this.mediaQueryList.removeEventListener('change', this.changeSourcesOnResize);

    if (this.hasAttribute('data-hover-play') && this.mediaWrapper) {
      this.mediaWrapper.removeEventListener('mouseenter', this.play);
      this.mediaWrapper.removeEventListener('mouseleave', this.stop);
    }
  }

  untilVisible(intersectionObserverOptions = { rootMargin: "0px 0px -50px 0px" }) {
    const onBecameVisible = () => {
      this.classList.add("became-visible");
      this.style.opacity = "1";
    };
    return new Promise((resolve) => {
      if (window.IntersectionObserver) {
        this.intersectionObserver = new IntersectionObserver((event) => {
          if (event[0].isIntersecting) {
            this.intersectionObserver.disconnect();
            requestAnimationFrame(() => {
              resolve();
              onBecameVisible();
            });
          }
        }, intersectionObserverOptions);
        this.intersectionObserver.observe(this);
      } else {
        resolve();
        onBecameVisible();
      }
    });
  }

  changeSourcesOnResize(event) {
    if (this.video.innerHTML === '') return;

    if (this.video.hasAttribute('data-mobile-poster') && event.matches) {
      this.video.poster = this.video.dataset.mobilePoster;
    } else if (this.video.hasAttribute('data-desktop-poster') && !event.matches) {
      this.video.poster = this.video.dataset.desktopPoster;
    }

    if (event.matches && this.video.hasAttribute('data-mobile-sources')) {
      this.video.pause();
      const mobileSources = JSON.parse(this.video.dataset.mobileSources);
      this.createAndAppendSources(mobileSources, true);
      this.video.load();
      this.video.play();
    } else if (!event.matches && this.video.hasAttribute('data-desktop-sources')) {
      this.video.pause();
      const desktopSources = JSON.parse(this.video.dataset.desktopSources);
      this.createAndAppendSources(desktopSources, true);
      this.video.load();
      this.video.play();
    }
  }

  createAndAppendSources(sources, removeExisting = false) {
    if (removeExisting) {
      this.video.innerHTML = '';
    }

    sources.forEach((source) => {
      const sourceElem = document.createElement('source');
      sourceElem.src = source.src;
      sourceElem.type = source.type;
      this.video.append(sourceElem);
    });
  }

  setExistingSources() {
    for (var source in this.video.children) {
      var videoSource = this.video.children[source];
      if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
        videoSource.src = videoSource.dataset.src;
      }
    }
  }

  play() {
    clearTimeout(this.timeoutId); // clear the timeout

    if (this.hasAttribute('loaded')) {
      this.video.play();
      return;
    }

    if (this.video.hasAttribute('data-desktop-sources')) {
      if (this.video.hasAttribute('data-mobile-sources') && window.matchMedia('(max-width: 749px)').matches) {
        const mobileSources = JSON.parse(this.video.dataset.mobileSources);
        this.createAndAppendSources(mobileSources);
      } else {
        const desktopSources = JSON.parse(this.video.dataset.desktopSources);
        this.createAndAppendSources(desktopSources);
      }
    } else {
      this.setExistingSources();
    }

    this.video.addEventListener('canplay', () => {
      this.setAttribute('loaded', 'true');
      this.video.play();
    });
    this.video.load();
  }

  stop() {
    const transitionDuration = parseFloat(window.getComputedStyle(this.video).transitionDuration) * 1000;

    if (this.hasAttribute('loaded')) {
      this.timeoutId = setTimeout(() => {
        this.video.pause();
        this.video.currentTime = 0;
      }, transitionDuration ?? 0);
    }
  }
}
customElements.define('lazy-video', LazyVideo);

/**
 * Prefetches a page by adding a <link> element to the document's head.
 * @param {string} href - The URL of the page to prefetch.
 * @param {string} [priority='auto'] - The priority of the prefetch request. Defaults to 'auto'.
 * @param {'link' | 'speculation'} [method='link'] - The method to use for prefetching the page. Defaults to 'link'.
 */
function addPrefetchLink(href, priority = 'auto', method = 'link') {
  try {
    new URL(href); // Validate URL
  } catch (e) {
    console.error('Invalid URL', e);
    return;
  }
  if (window.location.href === href) return;

  try {
    if (method === 'speculation') {
      if (document.querySelector(`script[type="speculationrules"][data-href="${href}"]`)) return;

      const specRuleScript = document.createElement('script');
      specRuleScript.type = 'speculationrules';
      specRuleScript.dataset.href = href;
      const specRule = {
        prefetch: [
          {
            urls: [href],
            eagerness: 'immediate',
          },
        ],
      };
      specRuleScript.textContent = JSON.stringify(specRule);
      document.body.append(specRuleScript);
    } else {
      if (document.querySelector(`link[rel="prefetch"][href="${href}"]`)) return;

      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      link.fetchPriority = priority;
      link.as = 'document';
      document.head.appendChild(link);
    }
  } catch (e) {
    console.error('Failed to prefetch page', e);
  }
}

/**
 * Prefetches pages based on the specified method.
 * @param {'mouseover' | 'intersection'} method - The method to use for prefetching pages.
 */
function initPagePrefetching(deviceMethod) {
  if (!shouldUsePrefetching()) return;
  if (deviceMethod !== 'mouseover' && deviceMethod !== 'intersection') return;

  const prefetchMethod =
    HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules') ? 'speculation' : 'link';

  // TODO: Fall back to link prefetching if speculation prefetch fails

  const prefetchRegions = ['products', 'collections', 'pages', 'blogs', 'policies', 'search'];
  const prefetchLinkRegex = new RegExp(`^(\\/|(\\/(?:${prefetchRegions.join('|')})(\\/.*)?))$`);
  const prefetchLinks = document.querySelectorAll('a[href]');

  const handleMouseOver = (event) => addPrefetchLink(event.currentTarget.href, 'high', prefetchMethod);

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        addPrefetchLink(entry.target.href, 'high', prefetchMethod);
        observer.unobserve(entry.target);
      }
    });
  });

  prefetchLinks.forEach((link) => {
    if (prefetchLinkRegex.test(link.pathname)) {
      if (deviceMethod === 'mouseover') {
        link.removeEventListener('mouseover', handleMouseOver);
        link.addEventListener('mouseover', handleMouseOver);
      } else if (deviceMethod === 'intersection') {
        observer.observe(link);
      }
    }
  });
}

/**
 * Returns the preferred method for prefetching based on the window size.
 * @returns {'intersection' | 'mouseover'} The preferred method for prefetching. Possible values are 'intersection' or 'mouseover'.
 */
const getPrefetchMethod = () => {
  return window.matchMedia('(hover: none)').matches ? 'intersection' : 'mouseover';
};

/**
 * Determine if devices should even consider prefetching
 * Low power mode, data saver, etc.
 * @returns {boolean} Whether or not prefetching should be used.
 */
const shouldUsePrefetching = async () => {
  // Data saver mode
  if (navigator.connection?.saveData) return false;

  // Low power mode
  // Javascript can't detect low power mode, so we'll work off actual battery level
  if (navigator.getBattery) {
    navigator.getBattery().then((battery) => {
      if (battery.level < 0.2) return false;
    });
  }
};

document.addEventListener('DOMContentLoaded', () => initPagePrefetching(getPrefetchMethod()));
// Update prefetch method on resize w/ debounce
window.addEventListener(
  'resize',
  debounce(() => initPagePrefetching(getPrefetchMethod()), 200)
);